
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Activity": [
      "CreatedCommentActivity",
      "CreatedHistoryActivity",
      "FillerActivity",
      "JoinedUserActivity",
      "PublishedPostActivity",
      "RepliedCommentActivity",
      "ThankedPostActivity"
    ],
    "CommentFields": [
      "Comment",
      "PublicComment"
    ],
    "GroupFields": [
      "Group",
      "PublicGroup"
    ],
    "MentionContent": [
      "MentionContentDelta",
      "MentionContentHighlights",
      "MentionContentSlack"
    ],
    "Notification": [
      "CommentNotification",
      "HistoryNotification",
      "InvitationNotification",
      "PostNotification",
      "ReactionNotification"
    ],
    "ObjectWithId": [
      "Organization",
      "Post",
      "PublicOrganization",
      "PublicSection",
      "PublicSeries",
      "PublicTopic",
      "PublicUser",
      "RedactedPost",
      "RedactedTopic",
      "Section",
      "Series",
      "SlimSeries",
      "SlimTopic",
      "SlimUser",
      "Topic",
      "User",
      "VisitorUser"
    ],
    "PostBacklink": [
      "Group",
      "Post",
      "Topic",
      "User"
    ],
    "PostFields": [
      "Post",
      "PublicPost"
    ],
    "PublicSearchResult": [
      "PublicPostSearchResult",
      "PublicTopicSearchResult"
    ],
    "PublicSectionItem": [
      "PublicPost",
      "PublicTopic"
    ],
    "PublicThreadFields": [
      "PublicCommentThread",
      "PublicReactionThread"
    ],
    "ReactionFields": [
      "PublicReaction",
      "Reaction"
    ],
    "RedactedPostFields": [
      "Post",
      "RedactedPost"
    ],
    "RedactedTopicFields": [
      "RedactedTopic",
      "Topic"
    ],
    "RootPostFields": [
      "Post",
      "PublicPost",
      "SlimPost"
    ],
    "RootThreadFields": [
      "CommentThread",
      "PublicCommentThread",
      "PublicReactionThread",
      "ReactionThread"
    ],
    "SearchResult": [
      "CommentSearchResult",
      "GroupSearchResult",
      "PostSearchResult",
      "TopicSearchResult",
      "UserSearchResult"
    ],
    "SectionItem": [
      "Post",
      "Topic"
    ],
    "SeriesFields": [
      "PublicSeries",
      "Series"
    ],
    "SlimExternalPostFields": [
      "ExternalPost",
      "SlimExternalPost"
    ],
    "SlimHistoryFields": [
      "History",
      "SlimHistory"
    ],
    "SlimPostFields": [
      "Post",
      "SlimPost"
    ],
    "ThreadFields": [
      "CommentThread",
      "ReactionThread"
    ],
    "TopicFields": [
      "PublicTopic",
      "Topic"
    ],
    "UserFields": [
      "PublicUser",
      "User",
      "VisitorUser"
    ]
  }
};
      export default result;
    